import React from 'react';

import { MCButton, SelectField, TextAreaField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import { lang, withRouter } from 'src/helpers';

import model from './model';
import { FormRow } from 'components/Form';

class VitalInfo extends BaseComponent {
  state = {
    apiName: 'addQuestions',
    adding: false
  };
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  save = (e) => {
    e.preventDefault();
    model.save();
  };

  renderVital = () => {
    const { handleChangeVital: handleChange, handleBlur } = model;
    const { invalid, loading } = model.getApiState(this.state.api);
    const { vitalInfo } = model.state;

    return (
      <form className={'mc-setting-vital-info'} onSubmit={this.save}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t('Vital Information')}</div>
        </div>
        <div className={'mc-form'}>
          <div className={'mc-form-row'}>
            <FormRow style={{ flex: 1 }}>
              <SelectField
                template={6}
                label={'Blood Group'}
                placeholder={'Select blood group'}
                options={constants.general.blood_groups}
                name={'bloodGroup'}
                value={vitalInfo.bloodGroup}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={invalid}
                disabled={loading}
              />
              <SelectField
                template={6}
                placeholder={'Select rh'}
                options={constants.general.rhesus_factors}
                name={'rhesusFactor'}
                label={'RH (Rhesus Factor)'}
                value={vitalInfo.rhesusFactor}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={invalid}
                disabled={loading}
              />
            </FormRow>
          </div>

          <div className={'mc-form-row'}>
            <FormRow style={{ flex: 1 }}>
              <TextAreaField
                value={vitalInfo.allergies}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={invalid}
                placeholder={'describe your allergies here'}
                template={6}
                rows={6}
                name={'allergies'}
                label={'Allergies'}
              />
            </FormRow>
          </div>
          {model.state.changed && (
            <div className={'mc-form-row'}>
              <div className={'mc-grow'}></div>
              <MCButton
                primary
                medium
                dark
                radius
                disabled={loading}
                type={'submit'}
                label={loading ? lang.t('Saving') + '...' : lang.t('Save')}
              />
            </div>
          )}
        </div>
      </form>
    );
  };

  render() {
    return <div className={'mc-main-content'}>{this.renderVital()}</div>;
  }
}

export default withRouter(VitalInfo);
